import React, {useState} from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import Swal from "sweetalert2";
import * as yup from 'yup';
import axios from "axios";
// import { Button } from 'bootstrap';

const validationSchema = yup.object({
    email: yup
      .string('Enter your email')
      .email('Enter a valid email')
      .required('Email is required'),
    password: yup
      .string('Enter your password')
      .required('Password is required')
});
export default function Login() {
    const [showPassword, setShowPassword] = useState(false);

    const handleShowPassword = () => { showPassword ? setShowPassword(false) : setShowPassword(true); }

    const navigate = useNavigate();
    const initialValues = {
        email: '',
        password: ''
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: values => {
            handleSubmit(values);            
        }
    });

    const handleSubmit = (values) => {
        axios.post('/api/auth/login', values).then((res) =>{
            if(res.data.success){
                console.log("login response===",res.data.data)
                localStorage.setItem('FF-authUser', JSON.stringify(res.data.data));
                if(res.data.data.role === 'SuperAdmin'){
                    navigate('/admins');
                }
                else{
                    navigate('/organizations');
                }
            }
            else{
                Swal.fire(res.data.message, '', 'info')
            }
        }).catch((error) => {
            Swal.fire(error.message, '', 'info')        
        });
    }

    return (
        <div className="authentication-wrapper authentication-cover">
            <div className="authentication-inner row m-0">
                <div className="d-none d-lg-flex col-lg-7 col-xl-8 align-items-center p-5">
                    <div className="w-100 d-flex justify-content-center">
                        <img src={process.env.REACT_APP_BASE_URL+"assets/img/login-image.png"} className="img-fluid login-wallpaper" alt="Login image" />
                    </div>
                </div>
                <div className="d-flex col-12 col-lg-5 col-xl-4 align-items-center authentication-bg p-sm-5 p-4">
                    <div className="w-px-400 mx-auto">
                        <div className="app-brand mb-4">
                            <Link to="/" className="app-brand-link gap-2">
                                <img src={process.env.REACT_APP_BASE_URL+"assets/img/first-feedback-logo.png"} alt=""  />
                            </Link>
                        </div>
                        <h4 className="mb-2">Welcome to ClearPoint360! 👋</h4>
                        <p className="mb-4">Please sign-in to your account and start the adventure</p>

                        <form id="formAuthentication" className="mb-3" onSubmit={formik.handleSubmit}>
                            <div className="mb-3">
                                <label htmlFor="email" className="form-label">Email or Username</label>
                                <input type="text" className="form-control" id="email" name="email" placeholder="Enter your email or username" autoFocus 
                                value={formik.values.email} onChange={formik.handleChange} onBlur={formik.handleBlur}/>
                                {formik.touched.email && formik.errors.email && (
                                    <div className="text-danger">{formik.errors.email}</div>
                                )}
                            </div>
                            
                            <div className="mb-3 form-password-toggle">                                
                                <div className="d-flex justify-content-between">
                                    <label className="form-label" htmlFor="password">Password</label>
                                    <Link to="/forgot_password">
                                        <span>Forgot Password?</span>
                                    </Link>
                                </div>
                                <div className="input-group input-group-merge">
                                    <input type={showPassword ? "text" : "password"} id="password" className="form-control" name="password" placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;" aria-describedby="password" 
                                    value={formik.values.password} onChange={formik.handleChange} onBlur={formik.handleBlur}/>
                                    <span className="input-group-text cursor-pointer" onClick={handleShowPassword}><i className={showPassword ? "bx bx-show" : "bx bx-hide"}></i></span>
                                </div>
                                {formik.touched.password && formik.errors.password && (
                                    <div className="text-danger">{formik.errors.password}</div>
                                )}
                            </div>
                            <div className="mb-3">
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" id="remember-me" />
                                    <label className="form-check-label" htmlFor="remember-me">
                                        Remember Me
                                    </label>
                                </div>
                            </div>
                            <button type="Submit" className="btn btn-primary d-grid w-100">
                                Sign in
                            </button>
                        </form>

                    </div>
                </div>
            </div>
        </div>
    )
}